// extracted by mini-css-extract-plugin
export default {"container":"logout_container__Wzr9l","userCard":"logout_userCard__5VGwp"};